// extracted by mini-css-extract-plugin
module.exports = {"root":"_1nVZg","disqusCommentsHolder":"_2QIGR","noDisqusIdMessage":"HtAM5"};